export const urls = {
  // API: "https://dedevelopers.org/aiword/",
  // PHP_API: "https://dedevelopers.org/aiword/",
  // Image_Uri: "https://dedevelopers.org/aiword/",

  API: "https://aiproject.codeperfecto.com/admin/",
  PHP_API: "https://aiproject.codeperfecto.com/admin/",
  Image_Uri: "https://aiproject.codeperfecto.com/admin/",

  // API: "http://192.168.100.171/aiword_latest/",
  // PHP_API: "http://192.168.100.171/aiword_latest/",
  // Image_Uri: "http://192.168.100.171/aiword_latest/",

  // API: "http://192.168.1.3/AI-Word-Backend/",
  // PHP_API: "http://192.168.1.3/AI-Word-Backend/",
  // Image_Uri: "http://192.168.1.3/AI-Word-Backend/",

  // API: "http://192.168.1.11/AI-Word-Backend/",
  // PHP_API: "http://192.168.1.11/AI-Word-Backend/",
  // Image_Uri: "http://192.168.1.11/AI-Word-Backend/",
};
